import React from 'react';
import PropTypes from 'prop-types';
import styles from './FuneralHomeHeader.styl';
import _isNil from 'lodash/isNil';
import _partial from 'lodash/partial';
import _pick from 'lodash/pick';
import {bindMethods, setRef} from '../../utilities/componentHelpers';
import {buildUrl} from '../../utilities/urlHelpers';
import {CloseXIcon} from '../../Svgs';
import config from '../../../../appConfig/AppConfig';

const cacheUrl = config().environmentalUrl.cacheUrl;
const mobileBreakpoint = 850;
const LAYOUT_SMALL = 'small';
const LAYOUT_LARGE = 'large';

export default class FuneralHomeHeader extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    isMobile: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      hamburgerActive: false,
      layout: props.isMobile ? LAYOUT_SMALL : LAYOUT_LARGE,
      mobileMenuHeight: 0,
    };

    this.setInnerNavRef = _partial(
      setRef,
      _partial.placeholder,
      'mobileNavInner',
      this
    );

    bindMethods(this, ['handleHamburgerClick', 'handleResize']);
  }

  /**
   * Make sure there is a window object and data before adding event listeners.
   * @return {Void} Returns nothing.
   */
  componentDidMount() {
    if (!_isNil(this.props.data) && window) {
      window.addEventListener('resize', this.handleResize);
      // graceful fallback for when an app isn't passing the isMobile flag
      // but needs the mobile menu to display on page load.
      if (!this.props.isMobile && window.innerWidth < mobileBreakpoint) {
        const timeout = 500;

        setTimeout(this.handleResize, timeout);
      }
    }
  }

  /**
   * Remove event listeners.
   * @return {Void} Returns nothing.
   */
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  /**
   * Sets the layout (large or small) based on screen side
   * @return {Void} Returns nothing.
   */
  handleResize() {
    if (window) {
      const nextState = {};

      nextState.layout =
        window.innerWidth > mobileBreakpoint ? LAYOUT_LARGE : LAYOUT_SMALL;
      this.setState(nextState);
    }
  }

  /**
   * Set the states for the hamburger icon click.
   * @return {Void} Returns nothing.
   */
  handleHamburgerClick() {
    const nextActive = !this.state.hamburgerActive;

    this.setState({
      hamburgerActive: !this.state.hamburgerActive,
      mobileMenuHeight: nextActive ? this.mobileNavInner.offsetHeight : 0,
    });
  }

  render() {
    const {
      data: {data},
    } = this.props;

    if (data) {
      const {
        logo: {
          url: logoUrl = null,
          src: logoSrc = null,
          target: logoTarget = '_self',
        },
        styles: headerStyles = {},
      } = data;
      const backgroundStyle = _pick(headerStyles, ['backgroundColor']);
      const fontStyle = _pick(headerStyles, ['color']);
      const borderRightColorStyle = fontStyle.color
        ? {borderRightColor: fontStyle.color}
        : {};

      if (this.state.layout === LAYOUT_LARGE) {
        return (
          <div className={styles.FuneralHeaderLarge} style={backgroundStyle}>
            <div className={styles.innerContainer}>
              <div className={styles.leftContent}>
                {logoUrl && logoSrc && (
                  <a className={styles.logo} href={logoUrl} target={logoTarget}>
                    <img src={`${buildUrl(cacheUrl, logoSrc)}`} />
                  </a>
                )}
              </div>
              <div className={styles.rightContent}>
                <nav className={styles.navLinks}>
                  {data.menu.map((obj, index) => (
                    <span key={index} style={borderRightColorStyle}>
                      <a href={obj.url} style={fontStyle} target={obj.target}>
                        {obj.name}
                      </a>
                    </span>
                  ))}
                </nav>
              </div>
            </div>
          </div>
        );
      }
      const HAMBURGER_OPACITY = 0.55;

      return (
        <div className={styles.FuneralHeaderSmall}>
          <header style={backgroundStyle}>
            <div className={styles.headerTop}>
              {this.state.hamburgerActive ? (
                <span
                  className={styles.closeX}
                  onClick={this.handleHamburgerClick}
                >
                  <CloseXIcon />
                </span>
              ) : (
                <button
                  className={styles.hamburger}
                  onClick={this.handleHamburgerClick}
                  style={backgroundStyle}
                  type="button"
                >
                  <span />
                </button>
              )}
              {logoUrl && logoSrc && (
                <a href={logoUrl} target={logoTarget}>
                  <span className={styles.logo}>
                    <img src={`${buildUrl(cacheUrl, logoSrc)}`} />
                  </span>
                </a>
              )}
            </div>
            <div
              className={styles.navOuter}
              style={{height: this.state.mobileMenuHeight}}
            >
              <nav className={styles.mainNav} ref={this.setInnerNavRef}>
                <div className={styles.items}>
                  {data.menu &&
                    data.menu.map((obj, i) => (
                      <div key={i}>
                        <div className={styles.default}>
                          <a href={obj.mUrl} target={obj.target}>
                            {obj.name}
                          </a>
                        </div>
                      </div>
                    ))}
                </div>
              </nav>
            </div>
            <div
              className={styles.backDrop}
              onClick={this.handleHamburgerClick}
              style={{
                height: this.state.hamburgerActive ? '1400px' : 0,
                opacity: this.state.hamburgerActive ? HAMBURGER_OPACITY : 0,
              }}
            />
          </header>
        </div>
      );
    }
    const noData = {display: 'none'};

    return <div style={noData}>load error</div>;
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/library/FuneralHomeHeader/FuneralHomeHeader.js